/**
 * CourseSession — expands / collapses the session description on click.
 *
 * Replaces T.Module.CourseSession (c-course-session.js).
 */
export class CourseSession {
  private ctx: HTMLElement;
  private description: HTMLElement | null;
  private abortController: AbortController;

  constructor(el: HTMLElement) {
    this.ctx = el;
    this.description = el.querySelector('.course-session__description');
    this.abortController = new AbortController();
  }

  init(): this {
    this.ctx.addEventListener(
      'click',
      () => this.description?.classList.toggle('course-session__description--close'),
      { signal: this.abortController.signal },
    );
    return this;
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="course-session"]')
      .forEach((el) => new CourseSession(el).init());
  }
}
